import React, { Component, Fragment } from "react";
import { NavLink } from "react-router-dom";
import List from "./List";
import AppContext from "../../../contexts/AppContext";
import NoData from "../../utilities/NoData";
import LoadingData from "../../utilities/LoadingData";
import Header from "../account/Header";
import AccountNav from "../account/AccountNav";
import { records } from "../../../services/visitor";

class Visitors extends Component {
    state = {
        items: [],
        meta: {},
        query: "",
        loading: true,
        free_user:false
    };
    onQueryChange = field => {
        this.setState({ query: field.target.value });
    };
    componentDidMount() {
        records(1)
            .then(response => {
                this.setState({
                    items: response.data,
                    meta: response.meta,
                    loading: false
                });
            })
            .catch(error => {
                console.log("===")
                console.log(error.response.status)
                if (error.response.status == 422) {                
                    this.setState({free_user:true});
                 }else{
                this.context.state.handelError(error);
                 }
            });
    }

    render() {
        return (
            <Fragment>
               
               <Header></Header>
                	{/* <section className="dashboard-nav">
		                <div className="container">
		            	    <div className="head">
		            		    <h1>Portfolio</h1>
		            		</div>		            		
		            		<AccountNav></AccountNav>
		            	</div>
		            </section> */}
					<section className="portfolioDetails_v2 pt-md-15 pb-md-40 pb-20 pt-20 mt-4">
						<div className="container writer-container">
							<div className="row">
								<div className="col-md-3">    
									<div className="card custom">
								        <div className="card-header">
										    Portfolio
								    	</div>
								        <div className="card-body">
								    	    <nav className="custom-sidenav" id="myScrollspy">
								            	<ul className="list-group">	
													<li><NavLink to={`/account/portfolio`} exact={true}>Settings</NavLink></li>
													<li className='active'><NavLink to={`/account/portfolio/visitors`} exact={true}>Visitors</NavLink></li>
								            	</ul>
								            </nav>
								    	</div>	
								    </div>
								</div>	
								<div className="col-md-9 mt-md-0 mt-md-0 mt-4">									
                                    <div className="header">
                                        <div className="header-body">
                                            <div className="row align-items-center">
                                                <div className="col">
                                                    <h1 className="header-title">
                                                        Visitors
                                                    </h1>
                                                    <h6 className="header-pretitle">
                                                        Overview all available
                                                        Visitors
                                                    </h6>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                {!this.state.free_user?
                                    <div className="table-responsive">
                                        {this.state.loading === true ? (
                                            <LoadingData></LoadingData>
                                        ) : this.state.items.length >= 1 ? (
                                            <Fragment>
                                                {this.state.items.map(
                                                    (item, index) => {
                                                        return (
                                                            <List
                                                                item={item}
                                                                index={index}
                                                                key={index}
                                                            ></List>
                                                        );
                                                    }
                                                )}
                                            </Fragment>
                                        ) : (
                                            <NoData></NoData>
                                        )}
                                    </div>
                                    :
                                    <div className="unlock-plus mb-5">
									    <div className="row align-items-center">
										    <div className="col-lg-2 mb-3 mb-lg-0">
											    <img className="d-block m-auto m-lg-0 pr-0 pr-lg-4" src="/images/plus.png" alt="prowriter-plus"/>
											</div>
											<div className="col-lg-6 col-md-12 col-sm-6 col-12 mb-lg-0 mb-md-3 mb-sm-0 mb-3 text-lg-left text-md-center text-sm-left text-center">
											    <p>Launch and grow your freelance writing career by upgrading to <span>ProWriter Plus.</span></p>
											</div>
											<div className="col-lg-4 col-md-12 col-sm-6 col-12">
											    <a href="/account/settings/membership" target="_blank" className="btn btn-primary d-block">Upgrade to Plus</a>
											</div>
										</div>
									</div>
                                    }
                                </div>
							</div>
						</div>
					</section>
            </Fragment>
        );
    }
}
Visitors.contextType = AppContext;
export default Visitors;



// WEBPACK FOOTER //
// ./src/components/writer/visitors/Visitors.js